(function () {
  'use strict';

  var contourSelector =
    '.button--secondary:not(.quick-add__submit):not(.product-form__submit)';

  var variantSelector =
    '.product-form__input input[type="radio"] + label';

  var quantitySelector =
    'quantity-input.quantity';

  var primarySelector =
    '.button--primary,.quick-add__submit,.product-form__submit';

  var isMobileDevice = window.matchMedia(
    '(max-width: 749px), (hover: none) and (pointer: coarse)'
  ).matches;

  var isTouchDevice = isMobileDevice;

  if (isMobileDevice) {
    var mobileContourStyle = document.createElement('style');

    mobileContourStyle.textContent =
      '.zenora-mobile-contour-filled{' +
        'background:#c9a84c!important;' +
        'background-image:none!important;' +
        'border-color:#c9a84c!important;' +
        'color:#111!important;' +
        '-webkit-text-fill-color:#111!important;' +
        'text-shadow:none!important;' +
      '}' +
      '.zenora-mobile-contour-filled *{' +
        'color:#111!important;' +
        '-webkit-text-fill-color:#111!important;' +
        'text-shadow:none!important;' +
      '}' +
      '.zenora-mobile-contour-filled svg,' +
      '.zenora-mobile-contour-filled svg *{' +
        'fill:currentColor!important;' +
        'stroke:currentColor!important;' +
      '}';

    document.head.appendChild(mobileContourStyle);

    function enableMobileContourFill() {
      document.querySelectorAll(contourSelector).forEach(function (btn) {
        if (btn.dataset.zenoraMobileContour === 'true') {
          return;
        }

        btn.dataset.zenoraMobileContour = 'true';

        function fillButton() {
          btn.classList.add('zenora-mobile-contour-filled');
        }

        btn.addEventListener('pointerdown', fillButton, {
          passive: true
        });

        btn.addEventListener('touchstart', fillButton, {
          passive: true
        });

        btn.addEventListener('click', fillButton);
      });
    }

    function startMobileEffects() {
      enableMobileContourFill();

      new MutationObserver(function () {
        enableMobileContourFill();
      }).observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        startMobileEffects
      );
    } else {
      startMobileEffects();
    }

    return;
  }

  var style = document.createElement('style');

  style.textContent =
    '.zenora-contour-fill{color:#c9a84c!important;}' +
    '.zenora-contour-fill:hover{background-color:transparent!important;background-image:radial-gradient(ellipse 80px 55px at var(--zenora-x,50%) var(--zenora-y,50%),#c9a84c 0%,rgba(201,168,76,.85) 34%,rgba(201,168,76,.18) 58%,transparent 76%)!important;}' +
    '.zenora-contour-fill .zenora-cursor-text{position:relative;z-index:2;color:#c9a84c!important;mix-blend-mode:difference;}' +
    '.zenora-contour-fill:active,.zenora-contour-fill.zenora-contour-selected{background-color:#c9a84c!important;background-image:none!important;color:#111!important;box-shadow:0 0 14px rgba(201,168,76,.8)!important;}' +
    '.zenora-contour-fill:active .zenora-cursor-text,.zenora-contour-fill.zenora-contour-selected .zenora-cursor-text{color:#111!important;mix-blend-mode:normal;}' +
    '.zenora-variant-fill{color:#ffffff!important;}' +
    '.zenora-variant-fill:hover{background-color:transparent!important;background-image:radial-gradient(ellipse 80px 55px at var(--zenora-x,50%) var(--zenora-y,50%),#ffffff 0%,rgba(255,255,255,.94) 34%,rgba(255,255,255,.22) 58%,transparent 76%)!important;}' +
    '.zenora-variant-fill .zenora-cursor-text{position:relative;z-index:2;color:#ffffff!important;mix-blend-mode:difference;}' +
    '.zenora-quantity-fill:hover{background-color:transparent!important;background-image:radial-gradient(ellipse 95px 60px at var(--zenora-x,50%) var(--zenora-y,50%),#ffffff 0%,rgba(255,255,255,.94) 36%,rgba(255,255,255,.20) 62%,transparent 80%)!important;}' +
    '.zenora-quantity-fill:hover .quantity__button{background:transparent!important;}' +
    '.zenora-quantity-fill .quantity__button svg,.zenora-quantity-fill .quantity__button svg *{color:#ffffff!important;fill:currentColor!important;stroke:currentColor!important;mix-blend-mode:difference;}' +
    '.zenora-quantity-fill input[type="number"]{color:#ffffff!important;background:transparent!important;mix-blend-mode:difference;}' +
    '.zenora-primary-glow-target{position:relative!important;isolation:isolate;overflow:visible!important;}' +
    '.zenora-primary-glow{position:absolute;left:var(--zenora-x,50%);top:var(--zenora-y,50%);width:110px;height:85px;transform:translate(-50%,-50%);background:radial-gradient(ellipse,rgba(255,120,0,1) 0%,rgba(255,78,0,.98) 16%,rgba(225,6,0,.9) 38%,rgba(225,6,0,.42) 60%,transparent 82%);filter:blur(10px);opacity:0;pointer-events:none;z-index:-1;transition:opacity .15s ease;}' +
    '.zenora-primary-glow-target:hover .zenora-primary-glow{opacity:1;}';

  document.head.appendChild(style);

  function setCursorPosition(el, e) {
    var box = el.getBoundingClientRect();

    el.style.setProperty(
      '--zenora-x',
      ((e.clientX - box.left) / box.width * 100) + '%'
    );

    el.style.setProperty(
      '--zenora-y',
      ((e.clientY - box.top) / box.height * 100) + '%'
    );
  }

  function wrapTextNodes(element) {
    var walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT
    );

    var textNodes = [];
    var node;

    while ((node = walker.nextNode())) {
      if (
        node.nodeValue.trim() !== '' &&
        !node.parentNode.classList.contains('zenora-cursor-text')
      ) {
        textNodes.push(node);
      }
    }

    textNodes.forEach(function (textNode) {
      var span = document.createElement('span');

      span.className = 'zenora-cursor-text';
      span.textContent = textNode.nodeValue;

      textNode.parentNode.replaceChild(span, textNode);
    });
  }

  function addCursorTracking(el) {
    if (isTouchDevice) {
      return;
    }

    el.addEventListener('pointermove', function (e) {
      setCursorPosition(el, e);
    });
  }

  function enableContourEffect() {
    document.querySelectorAll(contourSelector).forEach(function (btn) {
      if (btn.dataset.zenoraContourFill === 'true') {
        return;
      }

      btn.dataset.zenoraContourFill = 'true';
      btn.classList.add('zenora-contour-fill');

      wrapTextNodes(btn);
      addCursorTracking(btn);

      btn.addEventListener('click', function () {
        btn.classList.add('zenora-contour-selected');
      });
    });
  }

  function enableVariantEffect() {
    document.querySelectorAll(variantSelector).forEach(function (btn) {
      if (btn.dataset.zenoraVariantFill === 'true') {
        return;
      }

      btn.dataset.zenoraVariantFill = 'true';
      btn.classList.add('zenora-variant-fill');

      wrapTextNodes(btn);
      addCursorTracking(btn);
    });
  }

  function enableQuantityEffect() {
    document.querySelectorAll(quantitySelector).forEach(function (el) {
      if (el.dataset.zenoraQuantityFill === 'true') {
        return;
      }

      el.dataset.zenoraQuantityFill = 'true';
      el.classList.add('zenora-quantity-fill');

      addCursorTracking(el);
    });
  }

  function enablePrimaryEffect() {
    document.querySelectorAll(primarySelector).forEach(function (btn) {
      if (btn.dataset.zenoraPrimaryGlow === 'true') {
        return;
      }

      btn.dataset.zenoraPrimaryGlow = 'true';
      btn.classList.add('zenora-primary-glow-target');

      var glow = document.createElement('span');

      glow.className = 'zenora-primary-glow';
      btn.appendChild(glow);

      addCursorTracking(btn);
    });
  }

  function enableContactEffect() {
    document
      .querySelectorAll('.contact__button button[type="submit"]')
      .forEach(function (btn) {
        if (btn.dataset.zenoraPrimaryGlow === 'true') {
          return;
        }

        btn.dataset.zenoraPrimaryGlow = 'true';
        btn.classList.add('zenora-primary-glow-target');

        var glow = document.createElement('span');

        glow.className = 'zenora-primary-glow';
        btn.appendChild(glow);

        addCursorTracking(btn);
      });
  }

  function enableContinueShoppingEffect() {
    document
      .querySelectorAll('a.button[href="/collections/all"]')
      .forEach(function (btn) {
        if (btn.dataset.zenoraPrimaryGlow === 'true') {
          return;
        }

        btn.dataset.zenoraPrimaryGlow = 'true';
        btn.classList.add('zenora-primary-glow-target');

        var glow = document.createElement('span');

        glow.className = 'zenora-primary-glow';
        btn.appendChild(glow);

        addCursorTracking(btn);
      });
  }

  function enableCartNotificationEffect() {
    var btn = document.getElementById('cart-notification-button');

    if (
      !btn ||
      (
        btn.dataset.zenoraContourFill === 'true' &&
        btn.querySelector('.zenora-cursor-text')
      )
    ) {
      return;
    }

    btn.dataset.zenoraContourFill = 'true';
    btn.classList.add('zenora-contour-fill');

    wrapTextNodes(btn);
    addCursorTracking(btn);

    btn.addEventListener('click', function () {
      btn.classList.add('zenora-contour-selected');
    });
  }

  function enableTrashEffect() {
    document.querySelectorAll('a.button--tertiary').forEach(function (btn) {
      if (btn.dataset.zenoraContourFill === 'true') {
        return;
      }

      btn.dataset.zenoraContourFill = 'true';
      btn.classList.add('zenora-contour-fill');

      addCursorTracking(btn);

      var svg = btn.querySelector('svg');

      if (svg) {
        svg.style.position = 'relative';
        svg.style.zIndex = '2';
        svg.style.color = '#c9a84c';
        svg.style.mixBlendMode = 'difference';
      }
    });
  }

  function enableCheckoutEffect() {
    var btn = document.getElementById('checkout');

    if (
      !btn ||
      btn.dataset.zenoraPrimaryGlow === 'true'
    ) {
      return;
    }

    btn.dataset.zenoraPrimaryGlow = 'true';
    btn.classList.add('zenora-primary-glow-target');

    var glow = document.createElement('span');

    glow.className = 'zenora-primary-glow';
    btn.appendChild(glow);

    addCursorTracking(btn);
  }

  function enableButtonEffects() {
    enableContourEffect();
    enableVariantEffect();
    enableQuantityEffect();
    enablePrimaryEffect();
    enableContactEffect();
    enableContinueShoppingEffect();
    enableCartNotificationEffect();
    enableTrashEffect();
    enableCheckoutEffect();
  }

  function startDesktopEffects() {
    enableButtonEffects();

    new MutationObserver(function () {
      enableButtonEffects();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startDesktopEffects
    );
  } else {
    startDesktopEffects();
  }
})();

/* Tarjetas: elevación al pasar el cursor */
(function () {
  'use strict';

  var cardHoverStyle = document.createElement('style');

  cardHoverStyle.textContent =
    '.card-wrapper,' +
    '.product-card-wrapper,' +
    '.card{' +
      'transition:transform .25s ease,box-shadow .25s ease!important;' +
    '}' +
    '.card-wrapper:hover,' +
    '.product-card-wrapper:hover,' +
    '.card:hover{' +
      'transform:translateY(-8px)!important;' +
      'box-shadow:0 14px 24px rgba(0,0,0,.35)!important;' +
    '}';

  document.head.appendChild(cardHoverStyle);
})();

/* Clic en la imagen de una tarjeta: abrir el producto */
(function () {
  'use strict';

  var clickableImageStyle = document.createElement('style');

  clickableImageStyle.textContent =
    '.zenora-card-image-clickable{cursor:pointer!important;}';

  document.head.appendChild(clickableImageStyle);

  function enableProductImageLink() {
    document
      .querySelectorAll('.card-wrapper, .product-card-wrapper')
      .forEach(function (card) {
        if (card.dataset.zenoraImageLink === 'true') {
          return;
        }

        var productLink = card.querySelector('a[href*="/products/"]');

        if (!productLink) {
          return;
        }

        var mediaEl =
          card.querySelector('.card__media') ||
          card.querySelector('.card__inner') ||
          card.querySelector('img');

        if (!mediaEl) {
          return;
        }

        card.dataset.zenoraImageLink = 'true';
        mediaEl.classList.add('zenora-card-image-clickable');

        mediaEl.addEventListener('click', function (event) {
          if (event.target.closest('a, button, input, label')) {
            return;
          }

          window.location.href = productLink.href;
        });
      });
  }

  function startProductImageLinks() {
    enableProductImageLink();

    new MutationObserver(function () {
      enableProductImageLink();
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startProductImageLinks
    );
  } else {
    startProductImageLinks();
  }
})();
